import { Injectable } from "@angular/core";
import { IDataSourceBackendParam, IFilter, IQuestionnaireResponse, ITPDAInfos, ITPDAParticipant } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { TPDAsApiService } from "./tpdasApi.service";

@Injectable({
  providedIn: "root",
})
export class TPDAsService {
  constructor(private tpdasApi: TPDAsApiService) {}

  public getTPDAInfos(params: IDataSourceBackendParam): Observable<ITPDAInfos[]> {
    const services = params.services?.length ? params.services.join(",") : undefined;
    const pageNumber = params.pageNumber;
    const lang = params.lang;
    const pageSize = params.pageSize;
    const search = params.search;
    const sortId = params.sortId;
    const sortOrder = params.sortOrder;
    const filters = JSON.stringify(params.filters);
    return this.tpdasApi.getTPDAInfos(lang, pageNumber, pageSize, search, sortId, sortOrder, filters, services);
  }

  public getNbTPDAInfos(lang: string, search?: string, filters?: IFilter[], servicesIds?: string[]): Observable<number> {
    const services = servicesIds?.length ? servicesIds.join(",") : undefined;
    return this.tpdasApi.getNbTPDAInfos(lang, search, filters, services);
  }

  public getTPDAQRs(TPDAId: string, idParticipant?: string): Promise<IQuestionnaireResponse[]> {
    return this.tpdasApi.getTPDAQRs(TPDAId, idParticipant).toPromise();
  }

  public getTPDAParticipants(TPDAId: string, idParticipant?: string): Promise<ITPDAParticipant[]> {
    return this.tpdasApi.getTPDAParticipants(TPDAId, idParticipant).toPromise();
  }
  public getTPDAConsentFormsPDFs(TPDAId: string, idParticipant?: string): Promise<Blob> {
    return this.tpdasApi.getTPDAConsentFormsPDFs(TPDAId, idParticipant).toPromise();
  }
  public getTPDAQRsPDFs(TPDAId: string, idParticipant?: string, qrId?: string): Promise<Blob> {
    return this.tpdasApi.getTPDAQRsPDFs(TPDAId, idParticipant, qrId).toPromise();
  }

  public sendTPDAInvitations(TPDAId: string, emails: string[], lang: string): Promise<string[]> {
    return this.tpdasApi.sendTPDAInvitations(TPDAId, emails, lang).toPromise();
  }
}
